//  Time-stamp: "Sat Jul 14 00:27:44 2001 by Automatic Bizooty (__blocks2pm.plx)"
module.exports = [
'[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]',
'[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]',
"", "", "", "~", '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]',
"..", "--", "-", "_", "_", "(", ") ", "\\{", "\\} ", "[", "] ", "[(", ")] ", "<<", ">> ", "<",
"> ", "[", "] ", "\\{", "\\}", '[?]', '[?]', '[?]', '[?]', "", "", "", "", "", "", "",
",", ",", ".", "", ";", ":", "?", "!", "-", "(", ")", "\\{", "\\}", "\\{", "\\}", "#",
"&", "*", "+", "-", "<", ">", "=", "", "\\\\", "\\$", "%", "\\@", '[?]', '[?]', '[?]', '[?]',
"", "", "", '[?]', "", '[?]', "", "", "", "", "", "", "", "", "", "",
"", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "",
"", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "",
"", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "",
"", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "",
"", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "",
"", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "",
"", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "",
"", "", "", "", "", "", "", "", "", "", "", "", "", '[?]', '[?]', "",
];
